export { tollReceipt };
const tollReceipt = () => {
  return [
    {
      label: 'Toll Receipts',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'time', header: 'Time' },
          { field: 'price', header: 'Total (RM)' },
          { field: 'location', header: 'Location' },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: 'Manage',
                  icon: 'icon-eye',
                  iconPack: 'feather',
                  show: function (self) {
                    return self.assetName != '' ? true : false;
                  },
                  click: {
                    component: 'ViewReceiptToll',
                    data: {
                      onReady: async (self) => {
                        return new Promise((resolve) => {
                          let args = self.data.rowData;
                          self.loadedReceipts = [args];
                          resolve(true);
                        });
                      },
                    },
                  },
                },
              ],
            },
          },
        ],
      },
      pdf: {
        title: 'Toll Receipts',
        colsWidth: [80, 103, 70, 70, 90, 150],
      },
    },
  ];
};
